import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {zip} from 'rxjs';
import {SpeiseplanService} from '../../../../obs.speiseplan/services/speiseplan.service';
import {BestellungService} from '../../../../../services/bestellung/bestellung.service';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {KundeService} from '../../../../../services/kunden/kunde.service';
import {environment} from '../../../../../environments/environment';
import {switchMap} from 'rxjs/operators';

@Component({
    selector: 'expressStorno-dialog',
    templateUrl: './expressStorno-dialog.component.html',
    styleUrls: ['./expressStorno-dialog.component.css'],
})
export class ExpressStornoDialogComponent implements OnInit {

  public apiZeitraum
  public aktiverZeitraum
  public speiseplanKunde
  public speiseplanBestellungen
  public kunde
  public aktuelleBestellungen = []
  public aktuelleMenueTexte = {}


  public speiseplanTage
  @ViewChild('zeitraumPicker') zeitraumPicker
  public freischalten = false
  public errorMsg = false
  public mobil

    constructor(
      @Inject(MAT_DIALOG_DATA) public data,
      private speiseplanService: SpeiseplanService,
      private bestellungService: BestellungService,
      private kundeService: KundeService,
      private router: Router,
      private matDialog: MatDialog,
    ) {
      moment.locale('de')
    }

    ngOnInit(){
      this.mobil = environment.type != 'web'
      this.speiseplanService.speiseplan_zeitraum()
        .pipe(switchMap((apiZeitraum) => {
          this.apiZeitraum = {
            von: moment.default().format('YYYY-MM-DD'),
            bis: apiZeitraum['bis']
          }
          return zip(
            this.speiseplanService.speiseplan_kunde(this.data.kunde.bestellerId, this.apiZeitraum.von, this.apiZeitraum.bis),
            this.bestellungService.bestellung_kunde(this.data.kunde.bestellerId, this.apiZeitraum.von, this.apiZeitraum.bis),
            this.kundeService._kunde_get()
          )
      })).subscribe(apiResponse => {
        this.speiseplanKunde = apiResponse[0]
        this.speiseplanBestellungen = apiResponse[1]
        this.kunde = apiResponse[2]
        this.speiseplanTage = this.speiseplanKunde.kunden[this.kunde.kundeId].speisePlanTage
      })
    }

    public expressStonobestaetigen(){
      this.bestellungService._menutexte = this.aktuelleMenueTexte
      this.aktuelleBestellungen.forEach((bestellung) => {
        this.bestellungService.bestellung_setzen(bestellung);
      });
      this.matDialog.closeAll()
      this.router.navigateByUrl('warenkorb');
    }

    public sucheBestellungen(zeitraum){
      this.aktiverZeitraum = zeitraum
      this.aktuelleBestellungen = []
      this.aktuelleMenueTexte = {}
      let bestellTagesMenues = 0
      for (let bestellTag in this.speiseplanBestellungen.kunden[this.data.kunde.bestellerId].tage) {
        if (moment.default(bestellTag) >= zeitraum.von && moment.default(bestellTag) <= zeitraum.bis) {
          bestellTagesMenues = 0
          for (let menuId of Object.values(this.speiseplanBestellungen.kunden[this.data.kunde.bestellerId].tage[bestellTag].bestellMenues)) {
            if (menuId['mengeAlt'] > 0) {
              this.aktuelleMenueTexte[menuId['menueTextId']] = this.speiseplanBestellungen.menuetexte[menuId['menueTextId']]
              let gesperrt = this.speiseplanKunde.menuetexte[menuId['menueTextId']].gesperrt
              let abbestellschluss = this.speiseplanTage[bestellTag].tagesMenues[menuId['menueId']].abbestellschluss
              if (gesperrt || new Date > new Date(abbestellschluss)){
                this.speiseplanBestellungen.kunden[this.data.kunde.bestellerId].tage[bestellTag].bestellMenues[menuId['menueId']]['mengeNeu'] = menuId['mengeAlt']
              }else{
                bestellTagesMenues++
              }
            }
          }
          if (bestellTagesMenues > 0 && !this.speiseplanTage[bestellTag].zustellPause){
            this.aktuelleBestellungen.push(this.speiseplanBestellungen.kunden[this.data.kunde.bestellerId].tage[bestellTag])
          }
        }
      }
      if (this.aktuelleBestellungen.length > 0){
        this.freischalten = true
      }
    }

  protected readonly environment = environment;
}
